export default $ => {
  const selectors = {};
  $('[data-scroll-highlight]').each(function () {
    selectors[$(this).data('scroll-highlight')] = {
      pad: $($(this).data('scroll-highlight-pad')).height(),
      element: $(this),
    };
  });

  const selector = Object.keys(selectors).join(', ');
  const highlightVisible = () => {
    $(selector).each(function () {
      const idAttribute = $(this).attr('id');
      const id = `#${idAttribute}`;
      const pad = selectors[id].pad;
      const scrollTop = $(window).scrollTop() + pad + 10;

      if (scrollTop >= $(this).offset().top) {
        $('[data-scroll-highlight]').removeClass('eScrollHighlightActive');
        selectors[id].element.addClass('eScrollHighlightActive');
      }
    });
  };

  $(window).scroll(highlightVisible);
  $('[data-scroll-highlight]').first().addClass('eScrollHighlightActive');
};



// WEBPACK FOOTER //
// ./assets/js/component/scroll/highlight-visible.js